import { useEffect, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";

//redux
import { useSelector } from "react-redux";

//styles
import styles from "./ModalBase.module.css";

const ModalBase = ({ modalKey, children }) => {
	const show = useSelector((state) => state.chat_modals.entries?.[modalKey]?.show);
	const modalRef = useRef();

	useEffect(() => {
		if (!show) return;
		const onKeyDown = (e) => {
			if (e.key === "Escape") window.store.emit('hide_modal', modalKey);
		};
		document.addEventListener("keydown", onKeyDown);

		return () => document.removeEventListener("keydown", onKeyDown);
	}, [show, modalKey]);

	if (!show) return null;

	return (
		<AnimatePresence>
			{show && (
				<motion.div
					ref={modalRef}
					className={styles.content}
					onMouseDown={(e) => e.stopPropagation()}
					initial={{ opacity: 0, scale: 0.95 }}
					animate={{ opacity: 1, scale: 1 }}
					exit={{ opacity: 0, scale: 0.95 }}
					transition={{ duration: 0.2 }}>
					{children}
				</motion.div>
			)}
		</AnimatePresence>
	);
};

export default ModalBase;
